import React, { useState } from "react";

// components
import { Row, Col, Button, FormGroup, Spinner, Input, Label } from "reactstrap";
import Select from 'react-select'
import InputDatePickerMesAno from "components/Inputs/InputDatePickerMesAno";
import { CSVLink } from "react-csv";
import LogsAlteracaoDre from "./components/LogsAlteracaoDre";

// utils
import { getSessionCookie } from 'utils/cookies';
import { formateDateApi2 } from "utils/formats";
import { showMessage } from "utils/message.js";

// api
import relatorio_api from "api/relatorio_api";
import { useEffect } from "react";

export default function RelLogAlteracaoDre({ history }) {

    var session = getSessionCookie();

    // const exportRef = React.useRef(null);
    // const exportRef2 = React.useRef(null);

    const [showLoading, setshowLoading] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [list_table, set_list_table] = useState([]);
    const [tipoDreSelecionado, set_tipoDreSelecionado] = useState();

    //Função para setar Mes/Ano inicial e final 
    const setMonths = () => {
        let currentDate = new Date();

        // Configurar data final como o último dia do mês atual ou a data atual
        let lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
        let endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), lastDayOfMonth);
        setEndDate(endDate)

        // Subtrair dois meses da data atual para obter a data inicial
        let initialDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 2, 1);
        setStartDate(initialDate)
    };

    useEffect(() => {
        setMonths()
    }, [])

    const handleDataSelecionada = (data) => {
        set_tipoDreSelecionado(data);
    }

    // const headersExport = [
    //     { label: 'Mes Ano Inicial', key: 'mesAnoInicial' },
    //     { label: 'Mes Ano Final', key: 'mesAnoFinal' },
    //     { label: 'Grupo Econômico', key: 'grupoEconomico' },
    //     { label: 'Qtd PDV', key: 'qtdePdv' },
    //     { label: 'Qtd PDV c/ Pendencia', key: 'qtdePdvPendencia' },
    //     { label: 'Status', key: 'statusDRE' },
    //     { label: 'Data Emissão Relatório', key: 'dataEmissaoRelatorio' }
    // ]
    // const [csvData, set_csvData] = useState([]);

    // const handleExportar = () => {
    //     setshowLoading(true);
    //     let body = {
    //         startDate: startDate,
    //         endDate: endDate,
    //         grupoEconomico: null
    //     }
    //     relatorio_api.getApuracaoDreMensalGE(body).then(result => {
    //         setshowLoading(false);
    //         if (result.status !== 200) {
    //             showMessage("Aviso", result.message, 'error', null);
    //         }
    //         else {
    //             if (result.data.length == 0) {
    //                 showMessage("Aviso", "Não existem dados para os filtros informados", 'error', null);
    //                 return;
    //             }
    //             set_csvData(result.data);
    //             exportRef.current.link.click();
    //         }
    //     })
    // }

    // const headersExport2 = [
    //     { label: 'Mes Ano', key: 'mesAno' },
    //     { label: 'Grupo Econômico', key: 'grupoEconomico' },
    //     { label: 'Cust Code', key: 'custCode' },
    //     { label: 'Nick Name', key: 'nickName' },
    //     { label: 'Status Dre', key: 'statusDre' },
    //     { label: 'Pendencia', key: 'pendencia' },
    //     { label: 'Data Implantação', key: 'dataImplantacaoString' },
    //     { label: 'Data Emissão Relatório', key: 'dataEmissaoRelatorio' }
    // ]
    // const [csvData2, set_csvData2] = useState([]);

    // const handleExportarDetalhado = () => {
    //     setshowLoading(true);

    //     let body = {
    //         startDate: startDate,
    //         endDate: endDate,
    //         grupoEconomico: null
    //     }
    //     relatorio_api.getApuracaoDreMensalLoja(body).then(result => {
    //         setshowLoading(false);
    //         if (result.status !== 200) {
    //             showMessage("Aviso", result.message, 'error', null);
    //         }
    //         else {
    //             if (result.data.length == 0) {
    //                 showMessage("Aviso", "Não existem dados para os filtros informados", 'error', null);
    //                 return;
    //             }
    //             set_csvData2(result.data);
    //             exportRef2.current.link.click();
    //         }
    //     })
    // }

    const [tipoDreTable, set_tipoDreTable] = useState('')

    const handleFiltrar = () => {
        if (tipoDreSelecionado != null) {
            set_tipoDreTable(tipoDreSelecionado.value);
        }
        if (!tipoDreSelecionado) {
            showMessage("Aviso", "Selecione Tipo DRE!", 'error', null);
            return
        }

        //Validação para o período máximo a ser buscado: 3 meses
        const diffInMonths = (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth());
        if (diffInMonths >= 3) {
            showMessage("Aviso", "Período selecionado não pode ser superior a 3 meses!", 'error', null);
            return
        }

        set_list_table([]);
        setshowLoading(true);
        let body = {
            startDate: formateDateApi2(startDate),
            endDate: formateDateApi2(endDate),
            tipoDre: tipoDreSelecionado.value
        }
        relatorio_api.getLogsAlteracaoDre(body).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                if (result.data.length == 0) {
                    showMessage("Aviso", "Não existem dados para os filtros informados", 'error', null);
                    return;
                }

                set_list_table(result.data);
            }
        })
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Row className="mb-4 align-items-end">
                    <Col lg="12" md="12" sm="12"><h4 className="mt-0 mb-0">LOGS - Alterações DRE</h4></Col>
                </Row>
                <Row className="mb-4 align-items-end">
                    <Col lg="2" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Mês/Ano (inicial)</label>
                            <InputDatePickerMesAno selected={startDate} onChange={(date) => setStartDate(date)} ></InputDatePickerMesAno>
                        </FormGroup>
                    </Col>
                    <Col lg="2" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Mês/Ano (final)</label>
                            <InputDatePickerMesAno selected={endDate} onChange={(date) => setEndDate(date)} ></InputDatePickerMesAno>
                        </FormGroup>
                    </Col>
                    <Col lg="3" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Tipo DRE</label>
                            <Select
                                name="tipoDre"
                                options={[
                                    { value: 'mensal', label: 'DRE Mensal' },
                                    { value: 'adm', label: 'DRE Administrativo' }
                                ]}
                                value={tipoDreSelecionado}
                                onChange={(data) => handleDataSelecionada(data)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="2" md="6" sm="12">
                        <Button color="info" type="button" onClick={handleFiltrar}><i className="fas fa-filter"></i>  Filtrar</Button>
                    </Col>
                </Row>
                {list_table.length > 0 &&
                    <div>
                        <LogsAlteracaoDre list_table={list_table} tipoDre={tipoDreTable}></LogsAlteracaoDre>
                    </div>
                }
            </div>
        </>

    );
}